var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCompassFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6173FE",
    d: "M9 0c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm3.919 4.779c-.19-.095-.414-.095-.604 0L7.492 7.19c-.13.065-.237.171-.302.302L4.78 12.315c-.167.333-.032.739.302.905.19.095.413.095.603 0l4.823-2.411c.13-.065.237-.171.302-.302l2.411-4.823c.167-.333.032-.739-.301-.905zM9 7.987c.56 0 1.012.454 1.012 1.013 0 .56-.453 1.012-1.012 1.012-.56 0-1.013-.453-1.013-1.012 0-.56.454-1.013 1.013-1.013z",
    transform: "translate(-1073 -681) translate(1073 681) translate(3 3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompassFilled);
export default __webpack_public_path__ + "static/media/icon-compass-filled.b1e8a00e.svg";
export { ForwardRef as ReactComponent };